/* GrubTerra shop-by-need menu: opens the photo panel on hover (mouse) or click/Enter (touch, keyboard). */
(function () {
  var item = document.querySelector('[data-gtn-shop]');
  if (item) {
    var btn = item.querySelector('.gtn__toggle');
    var hover = window.matchMedia('(hover: hover) and (pointer: fine)');
    var openTimer, closeTimer, hoverOpenedAt = 0, openedAtY = 0, noHoverUntil = 0;

    var open = function () {
      clearTimeout(closeTimer);
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      openedAtY = window.scrollY;
    };
    var close = function () {
      clearTimeout(openTimer);
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    };

    item.addEventListener('mouseenter', function () {
      if (!hover.matches || Date.now() < noHoverUntil) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { open(); hoverOpenedAt = Date.now(); }, 90);
    });
    item.addEventListener('mouseleave', function () {
      if (!hover.matches) return;
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, 300);
    });
    btn.addEventListener('click', function () {
      // A click right after hover opened it should not slam it shut.
      if (item.classList.contains('is-open') && Date.now() - hoverOpenedAt > 500) close();
      else open();
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && item.classList.contains('is-open')) { close(); btn.focus(); }
    });
    item.addEventListener('focusout', function (e) {
      if (e.relatedTarget) {
        if (!item.contains(e.relatedTarget)) close();
        return;
      }
      // No new focus target: a click on plain text inside the panel, or focus left the page.
      setTimeout(function () {
        if (!item.contains(document.activeElement) && !item.matches(':hover')) close();
      }, 0);
    });
    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) close();
    });
    // Scrolling away hides the sticky header, so don't leave the panel floating.
    window.addEventListener('scroll', function () {
      if (item.classList.contains('is-open') && Math.abs(window.scrollY - openedAtY) > 60) {
        noHoverUntil = Date.now() + 600;
        close();
      }
    }, { passive: true });
    // Back/forward cache restores the page as it was left; start closed.
    window.addEventListener('pageshow', function (e) { if (e.persisted) close(); });
  }

  // Same for the phone menu drawer (stock Dawn keeps it open after "back").
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var d = document.getElementById('Details-menu-drawer-container');
    if (!d || !d.hasAttribute('open')) return;
    d.removeAttribute('open');
    d.classList.remove('menu-opening');
    var s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden-desktop');
  });
})();
